<script>
  import { format } from 'svelte-i18n';
  import { Button, Col, Collapse, Input, Row } from '@sveltestrap/sveltestrap';

  export let sending = false;
  export let onSend;
  export let subject = '';
  export let body = '';
  export let sendEmail = false;
</script>

<div class="border-bottom pb-4">
  <Row>
    <Col>
      <Input type="checkbox" bind:checked={sendEmail} label={$format('label.BIZCARD.ASSIGN.SEND_CUSTOM_WELCOME')} />
      <Collapse isOpen={sendEmail}>
        <div class="pt-3">
          <Input
            type="text"
            bsSize="lg"
            placeholder={$format('label.BIZCARD.ASSIGN.EMAIL_SUBJECT_PLACEHOLDER')}
            bind:value={subject}
          />
          <Input
            class="mt-3"
            type="textarea"
            placeholder={$format('label.BIZCARD.ASSIGN.CUSTOM_MESSAGE_PLACEHOLDER')}
            bind:value={body}
          />
        </div>
      </Collapse>
    </Col>

    <Col sm={12} md={4} class="text-right">
      <Button color="primary" disabled={sending || (sendEmail && !(subject && body))} on:click={() => onSend()}>
        {$format('label.BIZCARD.ASSIGN.SEND')}
      </Button>
    </Col>
  </Row>
</div>
